import { Directive } from '@angular/core';
/**
 * @hidden
 */
var ItemContent = (function () {
    function ItemContent() {
    }
    ItemContent.decorators = [
        { type: Directive, args: [{
                    selector: 'ion-item,[ion-item]',
                    host: {
                        'class': 'item-block'
                    }
                },] },
    ];
    /** @nocollapse */
    ItemContent.ctorParameters = function () { return []; };
    return ItemContent;
}());
export { ItemContent };
//# sourceMappingURL=item-content.js.map


// WEBPACK FOOTER //
// item-content.ts